import * as tslib_1 from "tslib";
import HLabel from "../../../../../form/src/common/components/label.vue";
import { labelText } from "../../../../../form/src/schema/system-data-item-codes";
import { Component, Prop, Vue } from "vue-property-decorator";
let Create = class Create extends Vue {
    render(h) {
        return h('h-label', { props: { text: labelText
            } });
    }
};
tslib_1.__decorate([
    Prop()
], Create.prototype, "control", void 0);
Create = tslib_1.__decorate([
    Component({
        name: 'Create',
        components: {
            HLabel: HLabel
        }
    })
], Create);
export default Create;
